import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class Kraken2PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.KRAKEN2;
}

export default Kraken2PoiTileEntity;
